import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '@context/UserContext';
import { loadCustomObjectFieldsOnce } from '@hooks/useCustomObjectsFields';

export function useNewUser() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [availableRoles, setAvailableRoles] = useState<string[]>([]);
    const [allPossibleRoles, setAllPossibleRoles] = useState<string[]>([]);
    const { userIdRoles, selectedRole, setSelectedRole } = useUserContext();

    useEffect(() => {
        async function fetchCustomObjectFields() {
            try {
                setLoading(true);

                const fields = await loadCustomObjectFieldsOnce();
                
                setAllPossibleRoles(fields);

                const usedRoles = userIdRoles.map(item => item.role);

                const available = fields.filter((role: string) => !usedRoles.includes(role));

                setAvailableRoles(available);
            } catch (error) {
                console.error('Error fetching custom object fields:', error);
            } finally {
                setLoading(false);
            }
        }

        fetchCustomObjectFields();
    }, [userIdRoles]);
    
    const handleAddAccount = () => {
        if (!selectedRole) return;
        navigate('/review-user-account-new-user');
    };


    return {
        availableRoles,
        selectedRole,
        setSelectedRole,
        loading,
        handleAddAccount,
        allPossibleRoles,
        setAllPossibleRoles,
    };
}